import Text from '@/stories/components/Common/NewText'
import Link from '../Link'
import { TFooterColumnsData } from './types'
import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'
import { eventData, eventMapping } from './footer.tracking'

type TProps = {
  columnsData: TFooterColumnsData[]
  section?: string
}

const FooterLinksWidget = ({ columnsData, section }: TProps) => {
  const pushEvent = useAnalyticsEvent()

  const registerGAEvent = (label: string) => {
    const gtm4Payload = {
      eventData: {
        ...eventMapping[eventData.linkClick],
        eventLabel: label,
        section,
      },
    }
    pushEvent({ gtm4Payload })
  }

  return (
    <div className="grid grid-cols-1 gap-4 py-6 lg:grid-cols-2 xl:grid-cols-4">
      {columnsData.map((column, index) => {
        return (
          <div
            key={`${column.title}-${index}`}
            className="flex flex-col items-start gap-3"
          >
            <Text
              appearance="caption"
              tag="div"
              addClassName="text-brand-grey-light"
            >
              {column.title}
            </Text>
            <ul className="flex flex-col place-items-start gap-2.5">
              {column.listItem.map((item, index) => {
                return (
                  <li key={`${item.title}-${index}`}>
                    <Link
                      href={item.relative_path}
                      title={item.title}
                      className="text-brand-white text-brand-grey text-sm"
                      onClick={() => {
                        registerGAEvent(item.title)
                      }}
                    >
                      {item.title}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        )
      })}
    </div>
  )
}

export default FooterLinksWidget
